module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.href) ? _c('a', _vm._b({
    class: _vm.classObject,
    on: {
      "click": function($event) {
        return _vm.handleClick($event)
      }
    }
  }, 'a', _vm.$props, false), [_vm._t("default")], 2) : _c('button', _vm._b({
    class: _vm.classObject,
    on: {
      "click": function($event) {
        return _vm.handleClick($event)
      }
    }
  }, 'button', _vm.$props, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2149f4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Uloc/button/UButton.vue
// module id = 852
// module chunks = 2